import React from 'react';

export default function SpinnerLoading(){
    // eslint-disable-next-line @next/next/no-img-element
    return <div className="loader" key="loader_small"><img src="/images/layout/loading.svg" alt="Loading"/></div>
}
